import {useSelector} from "react-redux";
import {RootState} from "../store";
import {Enums} from "../apitypes";


export const useHasRole = (required: Enums<"UserRole">[]): boolean => {

    const roles = useSelector<RootState, Array<Enums<"UserRole">>>(s => (s.sessionState && s.sessionState.user?.userRoles?.roles) || [])

    return hasRole(roles, required)

}

export function hasRole(my: Array<Enums<"UserRole">>, requred: Array<Enums<"UserRole">>): boolean {
    if (!requred) {
        return true
    }
    var setA = new Set(my);
    var setB = new Set(requred);
    return Array.from(setA).filter(x => setB.has(x)).length > 0;
}
